import React from "react";
import classNames from "classnames";

export interface CustomerTooltipField {
    label: string;
    value: string;
}

interface Props {
    fields: CustomerTooltipField[];
}

export const CustomerTooltipContent: React.FC<Props> = ({ fields }) => (
    <>
        {fields.map((field, index) => (
            <React.Fragment key={field.label}>
                <span className="label">{field.label}</span>
                <p
                    className={classNames({
                        "mb-0": index === fields.length - 1,
                    })}
                >
                    {field.value}
                </p>
            </React.Fragment>
        ))}
    </>
);
